import type { DomainGroup } from "../types";

export const uiDomain: DomainGroup = {
  id: "ui",
  name: "Interfaz de Usuario",
  description: "Módulos de solo interfaz sin tablas asociadas",
  icon: "Layout",
  order: 1,
  status: "active",
  modules: [
    {
      id: "dashboard",
      name: "Dashboard",
      description: "Vista general del sistema",
      icon: "LayoutDashboard",
      permissions: ["canRead"],
      routes: ["/dashboard", "/super/dashboard"],
      navigation: {
        showInNav: true,
        contexts: ["main"],
        navOrder: 1,
        status: "active",
      },
      tables: [],
      readOnlyTables: [{ tableName: "companies" }],
    },
    {
      id: "settings",
      name: "Empresa",
      description: "Gestiona la configuración de tu empresa",
      icon: "Settings",
      permissions: ["canRead", "canUpdate"],
      routes: ["/settings", "/super/settings"],
      navigation: {
        showInNav: true,
        contexts: ["settings", "super"],
        navOrder: 0,
        status: "active",
      },
      tables: [],
      readOnlyTables: [{ tableName: "companies" }],
    },
    {
      id: "profiles",
      name: "Perfiles",
      description: "Gestión de perfiles de usuario",
      icon: "User",
      permissions: ["canRead", "canUpdate"],
      routes: ["/profile"],
      navigation: {
        showInNav: false,
        contexts: ["none"],
        navOrder: 999,
        status: "active",
      },
      tables: [],
      readOnlyTables: [{ tableName: "users" }],
    },
  ],
};
